<template>
	<div>
		<h2 class="titleFont p-pl-2 p-text-bold">Step 1: Program Selection</h2>

		<div>
			<h4
				class="p-d-flex p-flex-column p-flex-sm-row p-justify-center p-align-center"
			>
				<p class="p-pr-2">Please enter the number of students:</p>
				<p class="p-grid p-col-4 p-sm-2">
					<InputNumber
						v-model="numberOfStudents"
						:min="1"
						:max="10"
						showButtons
					/>
				</p>
			</h4>
		</div>
		<div v-for="studentNumber in numberOfStudents" :key="studentNumber">
			<!-- <div>
				<StudentInfoCard
					:studentNumber="studentNumber"
					:validateForm="validateForm"
					:validateAllStudentInfoForms="validateAllStudentInfoForms"
					@studentTotal="getStudentTotal"
				/>
			</div> -->
			<div>
				<OldStudentInfoCard
					:studentNumber="studentNumber"
					:validateForm="validateForm"
					:validateAllStudentInfoForms="validateAllStudentInfoForms"
					:showBusPlan="store.loadParamsFn.showBusPlan"
					:showMealPlan="store.loadParamsFn.showMealPlan"
					@studentTotal="getStudentTotal"
				/>
			</div>
		</div>

		<div v-if="totalOfAllStudents != 0" class="totalOfAllStudents p-text-right">
			<h3>
				Total Amount: ${{
					!isNaN(totalOfAllStudents) ? totalOfAllStudents.toFixed(2) : "0.00"
				}}
				CAD
			</h3>
		</div>

		<div class="p-d-flex p-jc-center p-mt-4">
			<Button
				label="Next"
				icon="pi pi-angle-right"
				iconPos="right"
				style="min-width: 120px; max-width: 120px"
				@click="nextStep()"
			/>
		</div>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";
import OldStudentInfoCard from "../OldStudentInfoCard.vue";
// import StudentInfoCard from "../StudentInfoCard.vue";
import { useVuelidate } from "@vuelidate/core";

export default {
	name: "S1Form",
	components: {
		// StudentInfoCard,
		OldStudentInfoCard,
	},
	data() {
		return {
			numberOfStudents: 1,
			validateForm: 0,
			totalOfAllStudents: 0,
			submitted: false,
			allStudentFormStates: [{}],
			studentTotalArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
			v$: useVuelidate(),
		};
	},
	props: {},
	methods: {
		nextStep() {
			this.validateForm += 1;
			for (let i = 1; i <= this.numberOfStudents; i++) {
				this.allStudentFormStates[i] = false;
			}
		},
		validateAllStudentInfoForms(validStudentInfoForm, studentNumber) {
			this.allStudentFormStates[studentNumber] = validStudentInfoForm;
			let validStates = Object.values(this.allStudentFormStates);
			let allFormsValid = true;
			for (let i = 0; i <= this.numberOfStudents; i++) {
				if (validStates[i] === false) {
					allFormsValid = false;
				}
			}

			if (allFormsValid) {
				this.store.setS1FormData({
					totalOfAllStudents: this.totalOfAllStudents,
				});
				this.$emit("nextStep");
			} else {
				this.scrollToFirstError();
			}
		},
		getStudentTotal(studentTotal, studentNumber) {
			// TODO: could save the data for validation in the same array too
			this.studentTotalArray[studentNumber] = studentTotal;
			this.totalOfAllStudents = 0;
			this.studentTotalArray.forEach((amount) => {
				this.totalOfAllStudents += amount;
			});
		},
		scrollToFirstError() {
			this.$nextTick(() => {
				if (document.querySelector(".p-error")) {
					let domRect = document
						.querySelector(".p-error")
						.getBoundingClientRect();

					window.scrollTo({
						left: domRect.left + document.documentElement.scrollLeft,
						top: domRect.top + document.documentElement.scrollTop - 100,
						behavior: "smooth",
					});
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.activeCard {
	border: 5px solid $primary-color;
}

.totalOfAllStudents {
	h3 {
		font-size: 1.5rem;
	}
}

.titleFont {
	font-size: 1.9rem;
}
</style>
